// extracted by mini-css-extract-plugin
module.exports =  {"transition":"transition--bLPdH"};